<template>
  <div class="container-fluid mt-2">
    <div class="row mt-3">
      <div class="col d-flex justify-content-start">
          <h4>Datos de mi empresa</h4>
      </div>
    </div>
    <div
      class="form-card"
      v-for="branchoffice in newbranchoffices"
      :key="branchoffice.id"
      >
      <branch-office-header
        :branchoffice="branchoffice"
        :new="false"
        :open="openId === branchoffice.id"
        @toggle="toggle(branchoffice.id)"
      ></branch-office-header>
      <branch-office-body
        :branchoffice="branchoffice"
        :first_child="first_child"
        :last_child="last_child"
        :new="false"
        :open="openId === branchoffice.id"
        :priceslists="priceslists"
        :funds="funds"
      ></branch-office-body>
    </div>
    <div class="form-card">
      <branch-office-header
        :branchoffice="newbranchoffice"
        :new="true"
        :open="openId === 'new'"
        @toggle="toggle('new')"
      ></branch-office-header>
      <branch-office-body
        :branchoffice="newbranchoffice"
        :new="true"
        :open="openId === 'new'"
      ></branch-office-body>
    </div>
  </div>
</template>

<script>
import branchOfficeBody from "./Branch-office-body";
import branchOfficeHeader from "./Branch-office-header";

export default {
  props: ["branchoffices", "priceslists", "funds"],
  data: function() {
    return {
      endpointurl: "/api/configs/",
      newbranchoffices: [],
      newbranchoffice: {},
      profile_image: null,
      selected: null,
      last_child: null,
      first_child: null,
      openId: null
    };
  },
  computed: {},
  mounted: function() {
    this.newbranchoffices = this.branchoffices;
    this.selected = this.branchoffices[0];
    this.first_child = this.selected.id;
    this.last_child = this.newbranchoffices[
      this.newbranchoffices.length - 1
    ].id;
    this.newbranchoffices.forEach(function(bo) {
      bo.options.elecbilling = bo.elecbilling;
    });
    this.openId = this.first_child;
  },
  methods: {
    toggle(id) {
      this.openId = this.openId === id ? null : id;
    }
  },
  components: {
    branchOfficeBody,
    branchOfficeHeader
  }
};
</script>
